module.exports = __webpack_public_path__ + "./kevin_34efb1072a9891468e55f88f9d1e56ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/kevin.png
// module id = 453
// module chunks = 0